import { render, staticRenderFns } from "./ListingBrands.vue?vue&type=template&id=0a7b8bf5&scoped=true&"
import script from "./ListingBrands.vue?vue&type=script&lang=js&"
export * from "./ListingBrands.vue?vue&type=script&lang=js&"
import style0 from "./ListingBrands.vue?vue&type=style&index=0&id=0a7b8bf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7b8bf5",
  null
  
)

export default component.exports